import React, { useEffect } from 'react'
import ProfileAvatar from '../global/ProfileAvatar'
import { useSelector, useDispatch } from 'react-redux'
import StudentListTable from './StudentListTable'
import { getBootcampStudentsRequest } from '../../../redux/action/bootcampStudents'

const StudentBody = () => {

    // OBJECT INITIALIZATION
    const dispatch = useDispatch()


    // STATES
    const {
        bootcampStudents,
        getBootcampStudentsLoading
    } = useSelector((state)=>{
        const { bootcampStudents } = state.bootcampStudentsReducer
        const {getBootcampStudentsLoading} = state.loadingIndicator
        return { 
            bootcampStudents, 
            getBootcampStudentsLoading 
        }
    })


    // SIDE EFFECTS
    useEffect(()=>{
        dispatch(getBootcampStudentsRequest())
    }, [])

    return (
        <section className='w-[80vw] mobile:w-full bg-[#E5E5E5] py-16 mobile:pb-8 mobile:px-0 px-12'>

            {/* header */}
            <header  className='container mx-auto mobile:px-4 flex justify-between items-center'>
                <div>
                    <p className='text-4xl mobile:leading-9 mobile:text-2xl font-semibold leading-[54px] text-[#1D2433]'>
                        Bootcamp Participants
                    </p>
                </div>

                {/* profile dp */}
                <div className='mobile:hidden'>
                    <ProfileAvatar />
                </div>
            </header>

            {/* body section */}
            <section className='container mx-auto w-full mt-12 mobile:px-4 flex flex-col gap-9'>

                <StudentListTable
                studentList={bootcampStudents}
                studentLoading={getBootcampStudentsLoading} />

            </section>
        </section>
    )
}

export default StudentBody